/* eslint-disable react/display-name */
import React, { memo } from 'react';

import { LayerPickerIconProps } from './iconUtilities';

export const PauseButtonIcon = memo(({ 
    backgroundFillColor = '#FFFFFF',
    symbolFillColor = '#666666',
    width = 18,
    height = 18
}: LayerPickerIconProps) =>
    <svg width={width} height={height} fill={backgroundFillColor} viewBox='0 0 13 16' id='ui-pause'>
        <rect id='pause-Rectangle-98' x='0' y='0' width='4' height='16' fill={symbolFillColor}/>
        <rect id='pause-Rectangle-99' x='9' y='0' width='4' height='16' fill={symbolFillColor}/>
    </svg>
);